export const teamMembers = [
  {
    name: 'Louis Shi',
    position: 'CEO / CTO Founder',
    image:
      'https://res.cloudinary.com/amunoali/image/upload/v1742152901/CashClever/Louis_nrxnlo.png',
    link: 'https://www.linkedin.com/in/louis-shi-b772b472/',
  },
  // {
  //   name: 'Ankur Jain',
  //   position: 'Co-Founder',
  //   image:
  //     'https://res.cloudinary.com/amunoali/image/upload/v1742152905/CashClever/Ankur_mqcfkv.jpg',
  //   link: 'https://www.linkedin.com/in/ankkur13',
  // },
  // {
  //   name: 'Muno Ali',
  //   position: 'Founding Engineer',
  //   image:
  //     'https://res.cloudinary.com/amunoali/image/upload/v1742152906/CashClever/muno_aaqpbl.jpg',
  //   link: 'https://www.linkedin.com/in/amunoali/',
  // },
  // {
  //   name: 'William Lin',
  //   position: 'Founding Engineer',
  //   image:
  //     'https://res.cloudinary.com/amunoali/image/upload/v1742152892/CashClever/William_agca5r.jpg',
  //   link: 'https://www.linkedin.com/in/wl96/',
  // },
  {
    name: 'Andy Wang',
    position: 'Founding Engineer',
    image: 'https://res.cloudinary.com/amunoali/image/upload/v1746479474/CashClever/Andy.png',
    link: 'https://www.linkedin.com/in/andy-wang177/',
  },
  // {
  //   name: 'Angelo Corvera',
  //   position: 'QA Analyst - Tester',
  //   image: 'https://res.cloudinary.com/amunoali/image/upload/v1746479474/CashClever/ANGELO.jpg',
  //   link: 'https://www.linkedin.com/in/angelo-corvera-69052a212/',
  // },
  // {
  //   name: 'Nina Chang',
  //   position: 'Founding UI/UX Designer',
  //   image: '',
  //   link: '',
  // }
  // {
  //   name: 'Prabha Neupane ',
  //   position: 'Founding Product Manager',
  //   image:
  //     'https://res.cloudinary.com/amunoali/image/upload/v1742152892/CashClever/William_agca5r.jpg',
  //   link: 'https://www.linkedin.com/in/andy-wang177/',
  // },
  // {
  //   name: '',
  //   position: 'Chief Executive Officer',
  //   image:
  //     'https://images.unsplash.com/photo-1531314888229-c4b4682c3118?q=80&w=1854&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  //   link: 'saffat.ifit',
  // },
];

export const MeetOurExpertTeamTitle = 'Meet Our Team';
export const MeetOurExpertTeamSubTitle =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget velit eu sapien varius.';
